import { render, staticRenderFns } from "./createCollection.vue?vue&type=template&id=3c0397bf&scoped=true"
import script from "./createCollection.vue?vue&type=script&lang=js"
export * from "./createCollection.vue?vue&type=script&lang=js"
import style0 from "./createCollection.vue?vue&type=style&index=0&id=3c0397bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0397bf",
  null
  
)

export default component.exports